import { useEffect, useRef } from "react";
import { Icon } from "./Icon";

export function FlyingDot({
  startX,
  startY,
  onDone,
}: {
  startX: number;
  startY: number;
  onDone: () => void;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) {
      onDone();
      return;
    }
    const form = el.parentElement?.querySelector("form");
    if (!form) {
      onDone();
      return;
    }
    const rect = form.getBoundingClientRect();
    const endX = rect.left + rect.width / 2;
    const endY = rect.top + rect.height / 2;
    el.animate(
      [
        {
          transform: `translate(${startX}px, ${startY}px) translate(-50%, -50%) scale(1)`,
          opacity: "1",
        },
        {
          transform: `translate(${endX}px, ${endY}px) translate(-50%, -50%) scale(0.5)`,
          opacity: "0",
        },
      ],
      { duration: 350, easing: "ease-in", fill: "forwards" }
    ).onfinish = onDone;
  }, [startX, startY, onDone]);
  return (
    <div
      ref={ref}
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 100,
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 28,
        height: 28,
        borderRadius: "50%",
        background: "var(--surface-primary)",
        boxShadow: "var(--elevation-low)",
        border: "0.5px solid var(--border-alpha)",
        color: "var(--text-primary)",
      }}
    >
      <Icon name="paperclip" size={12} />
    </div>
  );
}
